
const initialState = {
	// details: {}, 
    id: "",
    images: [],
    title : "", 
    calory : "", 
    count : "", 
    duration : "", 
    description : "", 
    ingredients_list : {}, 
    instructions : "", 
    basic_products: [],
    other_products: [],
    num_of_checked_products: 0,
    first_num_of_checked_products: 0, // zamani ke safheye joziyate yek pack baz mishe, chanta az mahsoolat tik khorde hastan. vase ineke vaghti mahsoolate dg tavasote karbar check ya uncheck mishan matne monaseb set konim vasash
    change_by_user: false, // tavasote karbar taghirati soorat gerefte ya kheyr. hanooz azash estefade nakardim
};
const foodPackage = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_FOOD_PACKAGE_DETAILS':
            // return {...state, details: action.details};
            return {...state, 
            	id: action.details.id, 
            	images: action.details.images, 
            	title: action.details.title, 
            	calory: action.details.calory, 
            	count: action.details.count, 
            	duration: action.details.duration, 
            	description: action.details.description, 
            	ingredients_list: action.details.ingredients_list, 
            	instructions: action.details.instructions,
            	basic_products: action.details.basic_products, 
            	other_products: action.details.other_products};


        case 'CHANGE_FOOF_PACKAGE_PRODUCT_CHECK':
            if(action.isBasic) {
                state.basic_products.forEach(product => {
                    if (product.id === action.productGradeId)
                        product.is_check = action.isCheck;
                });
            }
            else {
                state.other_products.forEach(product => {
                    if (product.id === action.productGradeId)
                        product.is_check = action.isCheck;
                });
            }    
            return {...state, state};



        case 'CHANGE_INPUT_NUMBER_PRODUCT_IN_FOOD_PACKAGE':
            if(action.isBasic) {
                state.basic_products.forEach(product => {
                    if (product.id === action.productGradeId) { 
                        let result = product.selectedAmount;
                        if(product.is_check) {
                            const {min_amount, inventory} = product;
                            const step = parseFloat(min_amount);
                            if (action.direction === "up")
                                result = product.selectedAmount + step;
                            else if (action.direction === "down") {
                                result = product.selectedAmount - step;
                            } else { // be soorate dasti adad vared shode
                                if (action.direction > parseInt(inventory)) {
                                    result = parseInt(inventory);
                                } else if (action.direction < step)
                                    result = step;
                                else
                                    result = action.direction;
                            }
                            if (result > parseInt(inventory))
                                result = parseInt(inventory);
                            else if (result < step)
                                result = step;
                            else
                                result = result % 1 === 0 ? result : parseFloat(result.toFixed(2));
                        }
                        else
                            result = product.selectedAmount;


                        product.selectedAmount = result;
                    }
                });
            }
            else {
                state.other_products.forEach(product => {
                    if (product.id === action.productGradeId) { 
                        let result = product.selectedAmount;
                        if(product.is_check) {
                            const {min_amount, inventory} = product;
                            const step = parseFloat(min_amount);
                            if (action.direction === "up")
                                result = product.selectedAmount + step;
                            else if (action.direction === "down") {
                                result = product.selectedAmount - step;
                            } else { // be soorate dasti adad vared shode
                                if (action.direction > parseInt(inventory)) {
                                    result = parseInt(inventory);
                                } else if (action.direction < step)
                                    result = step;
                                else
                                    result = action.direction;
                            }
                            if (result > parseInt(inventory))
                                result = parseInt(inventory);
                            else if (result < step)
                                result = step;
                            else
                                result = result % 1 === 0 ? result : parseFloat(result.toFixed(2));
                        }
                        else
                            result = product.selectedAmount;

                        product.selectedAmount = result;
                    }
                });
            }
            return {...state, state};           

        case 'SET_NUM_OF_CHECKED_PRODUCTS':
            return {...state, num_of_checked_products: action.num};

        case 'SET_FIRST_NUM_OF_CHECKED_PRODUCTS':
            return {...state, first_num_of_checked_products: action.num};

        case 'SET_FOOD_PACK_CHANGEd_BY_USER':
            return {...state, change_by_user: action.status};

        default:
            return state;
    }
};

export default foodPackage;
